<template>
    <div class="tsoft-header">
        <div class="d-flex align-items-center">
            <div>
                <router-link to="/orders">
                    <img :src="'/img/logo-tanasoft.svg'">
                </router-link>
            </div>
        </div>
        <div class="d-flex align-items-center ml-4" style="overflow: hidden;">
            <div class="mr-3">
                <router-link to="/profile">
                    <div class="tsoft-user-preview">
                        <template v-if="currentUser.avatar_path">
                            <img :src="currentUser.avatar_path" alt="userPhoto" />
                        </template>
                        <template v-else>
                            <b-avatar
                                :title="currentUser.name"
                                :size="28"
                                variant="secondary"
                                :text="nameAvatar(currentUser.name)"
                            ></b-avatar>
                        </template>
                        <span class="font-weight-bold text-brown mx-2 hidden-from-1141">{{ currentUser.name }}</span>
                    </div>
                </router-link>
            </div>
            <div>
                <div @click="logout">
                    <b-iconstack font-scale="2.5" class="cursor-pointer">
                        <b-icon stacked icon="circle-fill" variant="light-gray" />
                        <b-icon stacked icon="door-open" scale="0.5" variant="brown" />
                    </b-iconstack>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    data() {
        return {};
    },

    computed: {
        ...mapGetters('auth', ['currentUser']),
    },

    methods: {
        ...mapActions('auth', ['AUTH_LOGOUT']),

        nameAvatar(name) {
            if (!name) return '';
            const parts = name.trim().split(/\s+/);
            if (parts.length >= 2) {
                return (parts[0][0] + parts[1][0]).toUpperCase();
            }
            return name.slice(0, 2).toUpperCase();
        },

        logout() {
            this.AUTH_LOGOUT().then(() => {
                this.$toast.success('Выход выполнен успешно. Хорошего дня! ☀️', {
                    position: 'top-right',
                    timeout: 3000,
                    closeOnClick: true,
                    pauseOnFocusLoss: false,
                    pauseOnHover: false,
                    draggable: true,
                    draggablePercent: 1,
                    showCloseButtonOnHover: true,
                    hideProgressBar: true,
                    closeButton: 'button',
                    icon: 'fa fa-exclamation-triangle',
                    rtl: false,
                });
                this.$router.push('/login');
            });
        },
    },
};
</script>
